// src/MainRouter.jsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Layout from './layout/Layout';
import Home from './pages/home/Home';
import HeroEditor from "./pages/heroEditor/HeroEditor";
import ProductsPage from './pages/products/ProductsPage';
import EditProductPage from './pages/products/editProducts/EditProductPage';
import LoginPage from './pages/auth/LoginPage';
import SettingsPage from './pages/settings/SettingsPage';

import BrandsPage from './pages/brands/BrandsPage';
import BrandDetailPage from './pages/brands/BrandDetailPage';

import { isAuthed } from './auth';

function RequireAuth({ children }) {
    const authed = isAuthed();
    const loc = useLocation();
    if (!authed) {
        // передаємо "from", щоб після логіну вернутись
        return <Navigate to="/login" state={{ from: loc.pathname + loc.search }} replace />;
    }
    return children;
}

export default function MainRouter() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
                element={
                    <RequireAuth>
                        <Layout />
                    </RequireAuth>
                }
            >
                <Route index element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<Home />} />

                {/* PRODUCTS (company) */}
                <Route path="/products" element={<ProductsPage site="company" />} />
                <Route path="/products/new" element={<EditProductPage site="company" />} />
                <Route path="/products/:id" element={<EditProductPage site="company" />} />



                {/* BRANDS */}
                <Route path="/brands" element={<BrandsPage />} />
                <Route path="/brands/:id" element={<BrandDetailPage />} />
                <Route path="/hero" element={<HeroEditor />} />

                <Route path="/Hero" element={<HeroEditor />} />

                {/* SETTINGS */}
                <Route path="/settings" element={<SettingsPage />} />

                {/* fallback */}
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Route>
        </Routes>
    );
}
